<template>
  <div class="peoplechoice">
    <Header :title="$t('m.Address')"></Header>
    <!--1.搜索框-->
    <!--<input id="search" placeholder="搜索" type="text" @keyup.enter="mySearch" @input="mySearch($event)"/>-->
    <!-- <Icon class="iossearch" type="ios-search" /> -->
    <div :class="login=='mobile'?'top_Bar':'top_Bar_wechat'">
      <!--2.全选-->
      <div v-if="canChoose">
        <div v-if="myMode=='normal'">
          <Checkbox
            :value="checkAll"
            :indeterminate="indeterminate"
            @click.prevent.native="handleCheckAll()"
          >{{$t('m.SelectAll')}}</Checkbox>
        </div>

        <div v-if="myMode=='search'">
          <Checkbox
            :value="checkAllSearch"
            :indeterminate="indeterminate"
            @click.prevent.native="handleCheckAll()"
          >{{$t('m.SelectAll')}}</Checkbox>
        </div>
      </div>
      <!-- <Input
        search
        placeholder="搜索：部门或联系人"
        @on-search="mySearch()"
        style="width:240px"
        v-model="searchContent"
      />-->
      <span class="serchbox">
        <Icon type="ios-search"></Icon>
        <input
          @input="mySearch"
          class="searchinput"
          :placeholder="$t('m.PlsenterDepartmentConnector')"
          type="text"
          v-model="searchContent"
        />
      </span>
      <!-- <div class="bottoma bgc" @click="mySearch()">搜索</div> -->
      <!-- <button @click="mySearch()">搜索</button> -->
      <!--只有在选人时候才需要-->
      <!-- <div @click="sure" class="color" v-if="canChoose">确认</div> -->
    </div>

    <!--3.导航条-->
    <!--normal模式-->
    <div class="listBar color" v-if="myMode=='normal'">
      <!-- <Breadcrumb separator="<b class='demo-breadcrumb-separator'>></b>">
        <BreadcrumbItem v-for="(item,index)  in  departmentNavi" :key="index">
          <a class="color nav_a" @click="toDepartment(index)">{{item}}</a>
        </BreadcrumbItem>
      </Breadcrumb>-->
      <Breadcrumb separator=">">
        <BreadcrumbItem v-for="(item,index)  in  departmentNavi" :key="index">
          <a class="color nav_a" @click="toDepartment(index)">{{item}}</a>
        </BreadcrumbItem>
      </Breadcrumb>
    </div>
    <!--search模式-->
    <div class="listBar" v-if="myMode=='search'">
      <!-- <a @click="returnNormal()" class="color">>返回</a> -->
      <Icon type="md-arrow-dropleft-circle" @click="returnNormal()" class="color" />

      <Breadcrumb separator="<b class='demo-breadcrumb-separator'>></b>">
        <BreadcrumbItem v-for="(item,index)  in  departmentNaviSearch" :key="index">
          <a @click="toDepartment(index)">{{item}}</a>
        </BreadcrumbItem>
      </Breadcrumb>
    </div>
    <!--4.1第一次的页面-->
    <!--normal-->
    <div class="departmentList" v-if="myMode=='normal' && first">
      <!--<CheckboxGroup v-model="checkAllGroup" @on-change="departmentChange" >-->
      <div class="listName" v-for=" (item,index) in currentDepartmentList" :key="index">
        <!--如果部门的userAllCount为0,不显示checkbox-->
        <div class="department" v-if="item.userAllCount>0 && canChoose">
          <Checkbox :label="index" v-model="item.check" @on-change="departmentChange(item)">
            <span style="margin-left:0.2rem">{{item.title}}</span>
            <span>({{item.userCheckCount}}/{{item.userAllCount}})</span>
          </Checkbox>
        </div>
        <div class="department" v-else>
          <span style="margin-left:0.2rem">{{item.title}}</span>
          <span>({{item.userAllCount}})</span>
        </div>
        <!--ysy 只有有子部门或者用户，才显示这个-->
        <span
          v-if="(item.children!=null && item.children.length>0)
            || (item.userDirectList!=null && Object.keys(item.userDirectList).length>0)"
          @click="goNextDepartment(item)"
          class="rightImg"
        >
          <img src="../../assets/images/tx/04.png" alt />
        </span>
      </div>
      <!--</CheckboxGroup>-->
    </div>
    <!--search模式-->
    <div class="departmentList" v-if="myMode=='search' && firstSearch">
      <div class="listName" v-for=" (item,index) in currentDepartmentListSearch" :key="index">
        <!--如果部门的userAllCount为0,不显示checkbox-->
        <div class="department" v-if="item.userAllCount>0 && canChoose">
          <Checkbox :label="index" v-model="item.check" @on-change="departmentChange(item)">
            <span style="margin-left:0.2rem">{{item.title}}</span>
            <span>({{item.userCheckCount}}/{{item.userAllCount}})</span>
          </Checkbox>
        </div>
        <div class="department" v-else>
          <span style="margin-left:0.2rem">{{item.title}}</span>
          <span>({{item.userAllCount}})</span>
        </div>
        <!--ysy 只有有子部门或者用户，才显示这个-->
        <span
          v-if="(item.children!=null && item.children.length>0)
        || (item.userDirectList!=null && Object.keys(item.userDirectList).length>0)"
          @click="goNextDepartment(item)"
          class="rightImg"
        >
          <img src="../../assets/images/tx/04.png" alt />
        </span>
      </div>
      <!--加载用户列表-->
      <div class="userNameList" v-for="(item, key) in firstUserSearch" :key="key" :ref="key">
        <div class="item-list">
          <div class="userInfo" v-if="canChoose">
            <Checkbox :label="item.id" v-model="item.check" @on-change="userChange(item)">
              <span class="headerpicwarp">
                <img
                  :src="item.image?item.image:unLineimg"
                  @click.stop.prevent="getusermessage(item)"
                  alt
                  class="headerpic"
                />
              </span>
              <span class="username">
                <span>{{item.name}}</span>
              </span>
              <span class="userphone">{{item.mobile}}</span>
            </Checkbox>
          </div>
          <div class="userInfo" v-else>
            <span class="headerpicwarp">
              <img
                :src="item.image?item.image:unLineimg"
                @click.stop.prevent="getusermessage(item)"
                alt
                class="headerpic"
              />
            </span>
            <span class="username">
              <span>{{item.name}}</span>
            </span>
            <span class="userphone">{{item.mobile}}</span>
          </div>
        </div>
      </div>
    </div>

    <!--4.2不是首页的加载方式-->
    <!--normal-->
    <div class="departmentList" v-else-if="myMode=='normal' && !first">
      <!--<CheckboxGroup v-model="checkAllGroup"  @on-change="departmentChange"  >-->
      <!--1.不仅循环子部门-->
      <div class="listName" v-for=" (item,index) in currentDepartmentList['children']" :key="index">
        <!--如果部门的userAllCount为0,不显示checkbox-->
        <div class="department" v-if="item.userAllCount>0 && canChoose">
          <Checkbox :label="index" v-model="item.check" @on-change="departmentChange(item)">
            <span style="margin-left:0.2rem">{{item.title}}</span>
            <span>({{item.userCheckCount}}/{{item.userAllCount}})</span>
          </Checkbox>
        </div>
        <div class="department" v-else>
          <span style="margin-left:0.2rem">{{item.title}}</span>
          <span>({{item.userAllCount}})</span>
        </div>
        <!--ysy 只有有子部门或者用户，才显示这个-->
        <span
          v-if="(item.children!=null && item.children.length>0)
                    || (item.userDirectList!=null && Object.keys(item.userDirectList).length>0)"
          @click="goNextDepartment(item)"
          class="rightImg"
        >
          <img src="../../assets/images/tx/04.png" alt />
        </span>
      </div>
      <!--</CheckboxGroup>-->
      <!--2.加载用户列表-->
      <div
        class="allUser_wrap"
        v-if="currentDepartmentList['userDirectList']!=null  && Object.keys(currentDepartmentList['userDirectList']).length>0 "
      >
        <div class="allUser">
          <div
            class="userNameList"
            v-for="(item, key) in currentDepartmentList['userDirectList']"
            :key="key"
            :ref="key"
          >
            <!--map的key # A B-->
            <!-- <div class="listTitle">{{key}}</div>-->
            <div :index="key" class="title spebgc">{{key}}</div>
            <div class="item-list" v-if="canChoose">
              <div class="userInfo" v-for="innerItem in item" :key="innerItem.id">
                <Checkbox
                  style="width:100%"
                  :label="innerItem.id"
                  v-model="innerItem.check"
                  @on-change="userChange(innerItem)"
                >
                  <span class="headerpicwarp">
                    <img
                      :src="innerItem.image?innerItem.image:unLineimg"
                      @click.stop.prevent="getusermessage(innerItem)"
                      alt
                      class="headerpic"
                    />
                  </span>
                  <span class="username">
                    <span>{{innerItem.name}}</span>
                  </span>
                  <span class="userphone">{{innerItem.mobile}}</span>
                </Checkbox>
              </div>
            </div>
            <div class="item-list" v-else>
              <div class="userInfo" v-for="innerItem in item" :key="innerItem.id">
                <span class="headerpicwarp">
                  <img
                    :src="innerItem.image?innerItem.image:unLineimg"
                    @click.stop.prevent="getusermessage(innerItem)"
                    alt
                    class="headerpic"
                  />
                </span>
                <span class="username">
                  <span>{{innerItem.name}}</span>
                </span>
                <span class="userphone">{{innerItem.mobile}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-tilte bgc3">
          <span
            :key="index"
            @click="cur=index;tothis(item)"
            :class="{active:cur==index}"
            v-for="(item,index) in myset"
          >{{item}}</span>
        </div>
      </div>
    </div>
    <!--search-->
    <div class="departmentList" v-else-if="myMode=='search' && !firstSearch">
      <!--<CheckboxGroup v-model="checkAllGroup"  @on-change="departmentChange"  >-->
      <!--不仅循环子部门-->
      <div
        class="listName"
        v-for=" (item,index) in currentDepartmentListSearch['children']"
        :key="index"
      >
        <!--如果部门的userAllCount为0,不显示checkbox-->
        <div class="department" v-if="item.userAllCount>0 && canChoose">
          <Checkbox :label="index" v-model="item.check" @on-change="departmentChange(item)">
            <span style="margin-left:0.2rem">{{item.title}}</span>
            <span>({{item.userCheckCount}}/{{item.userAllCount}})</span>
          </Checkbox>
        </div>
        <div class="department" v-else>
          <span style="margin-left:0.2rem">{{item.title}}</span>
          <span>({{item.userAllCount}})</span>
        </div>
        <!--ysy 只有有子部门或者用户，才显示这个-->
        <span
          v-if="(item.children!=null && item.children.length>0)
                    || (item.userDirectList!=null && Object.keys(item.userDirectList).length>0)"
          @click="goNextDepartment(item)"
          class="rightImg"
        >
          <img src="../../assets/images/tx/04.png" alt />
        </span>
      </div>
      <!--</CheckboxGroup>-->
      <!--加载用户列表-->
      <div
        class="allUser_wrap"
        v-if="currentDepartmentListSearch['userDirectList']!=null  && Object.keys(currentDepartmentListSearch['userDirectList']).length>0 "
      >
        <div class="allUser">
          <div
            class="userNameList"
            v-for="(item, key) in currentDepartmentListSearch['userDirectList']"
            :key="key"
            :ref="key"
          >
            <div :index="key" class="title spebgc">{{key}}</div>
            <div class="item-list" v-if="canChoose">
              <div class="userInfo" v-for="innerItem in item" :key="innerItem.id">
                <Checkbox
                  :label="innerItem.id"
                  v-model="innerItem.check"
                  @on-change="userChange(innerItem)"
                >
                  <span class="headerpicwarp">
                    <img
                      :src="innerItem.image?innerItem.image:unLineimg"
                      @click.stop.prevent="getusermessage(innerItem)"
                      alt
                      class="headerpic"
                    />
                  </span>
                  <span class="username">
                    <span>{{innerItem.name}}</span>
                  </span>
                  <span class="userphone">{{innerItem.mobile}}</span>
                </Checkbox>
              </div>
            </div>
            <div class="item-list" v-else>
              <div class="userInfo" v-for="innerItem in item" :key="innerItem.id">
                <span class="headerpicwarp">
                  <img
                    :src="innerItem.image?innerItem.image:unLineimg"
                    @click.stop.prevent="getusermessage(innerItem)"
                    alt
                    class="headerpic"
                  />
                </span>
                <span
                  style="width:1.3rem;display:inline-block;margin-left:0.05rem;font-size:0.14rem; word-break:keep-all;white-space:nowrap;text-overflow:ellipsis"
                >{{innerItem.name}}</span>
                <span
                  style="display:inline-block;margin-left:0.05rem;font-size:0.14rem;"
                >{{innerItem.mobile}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-tilte bgc3">
          <span
            :key="index"
            @click="cur=index;tothis(item)"
            :class="{active:cur==index}"
            v-for="(item,index) in myset"
          >{{item}}</span>
        </div>
      </div>
    </div>

    <!-- 底部操作按钮 -->
    <div class="bottomButtons">
      <div @click="sure" class="bgc">{{$t('m.OKBtn')}}</div>
      <!-- <div @click="returnNormal" class="bgc">返回</div> -->
    </div>
    <!-- 弹框  开始 -->
    <div class="pop" v-if="popshow">
      <div class="templatepop">
        <div @click="closeallpop" class="popclosex">
          <Icon type="ios-close"></Icon>
        </div>
        <div style="height:1rem;text-align:center">
          <img :src="usermessage.image?usermessage.image:unLineimg" alt style="height:1rem;width:1rem;border-radius:50%" />
        </div>
        <div class="contentitem">
          <span class="leftspan">{{$t('m.NameColon')}}</span>
          {{usermessage.name}}
        </div>

        <div class="contentitem">
          <span class="leftspan">{{$t('m.UnitColon')}}</span>
          {{usermessage.departmentName}}
        </div>
        <div class="contentitem">
          <span class="leftspan">{{$t('m.MobileColon')}}</span>
          {{usermessage.mobile}}
        </div>
        <div class="contentitem">
          <span class="leftspan">{{$t('m.EMailColon')}}</span>
          {{usermessage.email}}
        </div>
        <div class="contentitem">
          <!-- <span class="leftspan">地址：</span> -->
        </div>
      </div>
    </div>
    <!-- 弹框  结束 -->
  </div>
</template>
<script>
import Search from "./userlist/Search";
import Header from "../header/header";
import { getFirstDepartment, addusr, live2 } from "../../assets/js/url";

export default {
  name: "peoplechoice",
  data() {
    return {
      unLineimg: require("../../../static/img/0.png"),
      login: "mobile",
      isGetShareLive: false,
      cur: 0, //默认选中第一个tab
      keyword: "",
      list: [],

      array: [],
      data: Object,
      myset: [
        "#",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z"
      ],
      ha: true,

      meetinguuid: "",
      usermessage: Object,
      //--ysy使用的字段---
      canChoose: false, //如果只是通讯录，不提供选择的功能，增加人的提供选择的功能
      userFromParent: "", //已经选择的用户
      addUserType: "", //选择与会人员还是主持人

      popshow: false, //用户显示的弹框是否出现
      allUseruuids: [], //最后获取选中的所有人
      allUserName: [],
      myMode: "normal", //模式，处在搜索模式search  还是正常模式normal
      departmentList: [], //从接口来的原始数据  最原始的
      searchContent: "", //搜索的内容
      //----normal模式下使用的字段
      first: true, //首页通讯录和其他页通讯录加载不同
      departmentStack: [], //根据操作入栈和出栈数据
      departmentNavi: ["返回"], //头部导航，要pop数据
      currentDepartmentList: [], //用户当前所在的部门数据
      checkAll: false, //全选的标记
      //---search模式下使用的字段
      firstSearch: false, //首页通讯录和其他页通讯录加载不同
      departmentStackSearch: [], //根据操作入栈和出栈数据
      departmentNaviSearch: [], //头部导航，要pop数据
      currentDepartmentListSearch: [], //用户当前所在的部门数据
      checkAllSearch: false, //全选的标记

      //search模式下多了一个首页会有人员的情况
      firstUserSearch: [],

      indeterminate: false,
      checkAllGroup: [] //选择部门？？
    };
  },
  components: {
    Header,
    Search
  },
  mounted() {
    this.getDepartmentAndUsers();
  },

  activated() {
    this.login = window.sessionStorage.getItem("login");
    this.initDataByAction();
  },
  deactivated() {
    this.$destroy(true); //销毁状态
  },
  methods: {
    // 直播分享选择人后过来
    getShareLive() {
      if (!this.allUseruuids.length) {
        this.$toast(this.$t('m.PlsSelectsharePerson'));
        return;
      }
      this.$http
        .post(live2, {
          userUUId: window.sessionStorage.getItem("UUID"),
          cfIdInWeMeet: window.sessionStorage.getItem("cfIdInWeMeet"),
          actionUser: this.allUseruuids.join(",")
        })
        .then(
          res => {
            if (res.data.status === 2000) {
              this.$toast(this.$t('m.MeetingShareOK'));
            } else {
              this.$toast(this.$t('m.MeetingShareFail'));
            }
            this.$router.push({
              path: "/meetingact",
              query: {
                cf_id: this.$route.query.cf_id,
                mcuId: this.$route.query.mcuId
              }
            });
          },
          err => {
            this.$toast(this.$t('m.MeetingShareFail'));
          }
        );
    },
    //区分从通讯录来的，还是增加与会人员的，还是增加主持人的，还是在会控里增加人员的
    initDataByAction() {
      this.countAllUserNum(); //初始化人数 和选择的状态

      var query = this.$route.query;
      this.canChoose = query.canChoose;
      if (this.canChoose) {
        //增加人的时候，先把数据还原，再去设置
        if ("name" in query) {
          //增加与会人员 or 主持人
          this.addUserType = query.name;
          this.userFromParent = this.$route.query.message; //从父页面来的用户
        } else if ("isGetShareLive" in query) {
          //从直播分享选择完后过来的
          this.isGetShareLive = true;
        } else {
          //会控里的增加人员
          this.addUserType = "";
          this.userFromParent = "";
        }
        this.setUserFromParent(); //设置来自父级用户的选中状态，设置已选人数
        this.setDepartmentCheckStatus(); //设置人后，部门的选中状态。
        this.ifAllCheck(); //是否被全选中
      }
    },

    //action0:请求 后台接口数据  first=true
    getDepartmentAndUsers() {
      this.$loadingshow();
      this.array = [];
      this.$http
        .post(getFirstDepartment, {
          useruuid: window.sessionStorage.getItem("UUID"),
          flat: window.sessionStorage.getItem("flat") //1表示微信 2是平台
        })
        .then(
          res => {
            this.$loadingclose();
            if (res.data.status == 2000) {
              const data = res.data.data;
              this.departmentList = data;

              this.currentDepartmentList = this.departmentList;
              // this.departmentNavi.push("返回"); //加入导航条数据
              this.initDataByAction();
            } else {
              this.$toast(res.data.data); //弹出错误信息
            }
          },
          err => {
            this.$loadingclose();
            this.$toast(this.$t('m.NetworkException'));
          }
        );
    },

    //action1:选中部门触发的事件
    departmentChange(item) {
      //1.设置当前部门 和其下的子部门和直接用户的checke值
      this.setCheckForDepartment(item, item["check"]);
      //2.设置current的  只要有一个check=false 就为false
      if (!item["check"]) {
        //如果是取消勾选的状态，就把checkAll=false
        this.setNoCheck();
      } else {
        this.ifAllCheck(); //要判断是不是把current里的children和userDirectList全选了
      }
      //3.设置当前部门 和其下的子部门的  已选人数
      this.countCheckUserNum4perDep(item);
    },

    //action2:选中用户触发的事件  已经通过绑定值了
    userChange(item) {
      //1..设置current的  只要有一个check=false 就为false
      if (!item.check) {
        this.setNoCheck();
      } else {
        this.ifAllCheck(); //要判断是不是把current里的children和userDirectList全选了
      }
    },

    //action3:跳转到下一级部门 ysy
    goNextDepartment(item) {
      //0.要进入下一级了，将当前级数据入栈
      if (this.myMode == "normal") {
        this.departmentStack.push(this.currentDepartmentList);
        this.currentDepartmentList = item;
        if (this.first) {
          this.first = false;
        }
        // this.departmentNavi.unshift("返回"); //加入导航条数据
        this.departmentNavi.push(item["title"]);
      } else if (this.myMode == "search") {
        this.departmentStackSearch.push(this.currentDepartmentListSearch);
        this.currentDepartmentListSearch = item;
        if (this.firstSearch) {
          this.firstSearch = false;
        }
        this.departmentNaviSearch.push(item["title"]);
      }
      if (this.canChoose) {
        //可选择的时候才去计算勾选状态
        this.setDepartmentCheckStatus();
        this.ifAllCheck();
      }
    },

    //action4:导航条里指定部门后的跳转 √
    toDepartment(index) {
      //1.判断点的是第几个 如果是第一个 first =true
      if (this.myMode == "normal") {
        if (index == 0) this.first = true;

        let popCount = this.departmentStack.length - index;

        for (let i = 0; i < popCount; i++) {
          this.currentDepartmentList = this.departmentStack.pop(); //把pop的值赋给current
          this.departmentNavi.pop();
        }
      } else if (this.myMode == "search") {
        if (index == 0) this.firstSearch = true;

        let popCount = this.departmentStackSearch.length - index;

        for (let i = 0; i < popCount; i++) {
          this.currentDepartmentListSearch = this.departmentStackSearch.pop(); //把pop的值赋给current
          this.departmentNaviSearch.pop(); //路径的值也pop
        }
      }
      if (this.canChoose) {
        this.setDepartmentCheckStatus();
        this.ifAllCheck();
      }
    },

    //action5:点击全选  将当前部门下的不管部门还是用户设为true
    handleCheckAll() {
      if (this.myMode == "normal") {
        this.checkAll = !this.checkAll;
        if (this.first) {
          for (let i = 0; i < this.currentDepartmentList.length; i++) {
            this.setCheckForDepartment(
              this.currentDepartmentList[i],
              this.checkAll
            ); //设置部门的状态
            this.countCheckUserNum4perDep(this.currentDepartmentList[i]); //设置这个部门的已选人数
          }
        } else {
          //子部门
          this.setCheckForDepartment(this.currentDepartmentList, this.checkAll);
          this.countCheckUserNum4perDep(this.currentDepartmentList);
        }
      } else if (this.myMode == "search") {
        this.checkAllSearch = !this.checkAllSearch;
        if (this.firstSearch) {
          for (let i = 0; i < this.currentDepartmentListSearch.length; i++) {
            this.setCheckForDepartment(
              this.currentDepartmentListSearch[i],
              this.checkAll
            );
            this.countCheckUserNum4perDep(this.currentDepartmentListSearch[i]);
          }
        } else {
          //子部门
          this.setCheckForDepartment(
            this.currentDepartmentListSearch,
            this.checkAll
          );
          this.countCheckUserNum4perDep(this.currentDepartmentListSearch);
        }
      }
    },

    //action7:点击确定选取人员  只有在选人的时候才会调用这个方法
    //要知道加的是主持人还是参会人
    //跳回到创建会议界面
    sure() {
      this.allUseruuids = []; //每次要清空一下数据，再统计
      this.allUserName = [];
      //循环this.departmentlist
      for (let i = 0; i < this.departmentList.length; i++) {
        this.getAllUsers(this.departmentList[i]);
      }
      if (this.isGetShareLive) {
        this.getShareLive(); // 直播分享
      } else if (this.addUserType == "") {
        this.addPeopleInConf(); //在会控里的增加人员
      } else {
        this.addPeopleInCreate(); //在建会里的增加人员，或者其他地方的加人【模板里】
      }
    },
    getAllUsers(perDep) {
      //获取自己的直接用户
      var usersMap = perDep["userDirectList"];
      for (var key in usersMap) {
        var usersList = usersMap[key];
        for (let i = 0; i < usersList.length; i++) {
          if (usersList[i].check == true) {
            //如果这个用户被选中就加入
            this.allUseruuids.push(usersList[i].useruuid);
            this.allUserName.push(usersList[i].name);
          }
        }
      }
      //获取部门的子部门
      var childrenDeps = perDep["children"];
      for (let j = 0; j < childrenDeps.length; j++) {
        this.getAllUsers(childrenDeps[j]);
      }
    },

    //action8:搜索
    mySearch() {
      //搜索的时候清空  字段的值
      this.initSearch();
      //方法一：直接通过event.data可以获得文本内容
      // var searchVal = document.getElementById("search").value;
      // console.log(searchVal);
      if (this.searchContent == "") {
        this.myMode = "normal";
      } else {
        this.myMode = "search"; //改变模式
        this.firstSearch = true;
        var departmentSearch = [];
        var searchUser = [];
        var depWait2Search = [];
        if (this.first) {
          //站在首页搜
          depWait2Search = this.currentDepartmentList;

          for (let i = 0; i < this.currentDepartmentList.length; i++) {
            let searchUserTmp = this.searchUsers(
              this.currentDepartmentList[i],
              this.searchContent
            );
            searchUser.push(...searchUserTmp);
          }
        } else {
          //不是在首页的，不应该搜索自己本身,从children开始搜
          depWait2Search = this.currentDepartmentList["children"];

          searchUser = this.searchUsers(
            this.currentDepartmentList,
            this.searchContent
          );
        }

        for (let i = 0; i < depWait2Search.length; i++) {
          var searchDep = this.searchDepartment(
            depWait2Search[i],
            this.searchContent
          );

          departmentSearch.push(...searchDep);
        }
        this.currentDepartmentListSearch = departmentSearch;
        this.firstUserSearch = searchUser;

        this.departmentNaviSearch.push(this.$t('m.SearchResult')); //加入导航条数据
      }
    },

    //action9:搜索状态下点击【返回】回到normal模式
    returnNormal() {
      this.myMode = "normal";
      //设置状态
      if (this.canChoose) {
        this.setDepartmentCheckStatus();
        this.ifAllCheck();
      }
    },

    //action10:右侧ABCD导航的
    tothis(item) {
      if ($('[index="' + item + '"]').length > 0) {
        const top = $('[index="' + item + '"]').offset().top;

        $(window).scrollTop(top - $(window).height() * 0.2);
      }
    },

    //显示人员的信息的 弹框的
    getusermessage(item) {
      this.usermessage = item;
      this.popshow = true;
    },
    //关闭弹框
    closeallpop() {
      this.popshow = false;
    },

    //第一次从接口拿到数据时候计算
    countAllUserNum() {
      for (let i = 0; i < this.departmentList.length; i++) {
        this.countAllUserNum4perDep(this.departmentList[i]);
      }
    },
    //初始化部门的所有用户个数，和初始选中人数
    countAllUserNum4perDep(perDep) {
      perDep["userCheckCount"] = 0; //初始化
      var allCount = 0;
      //1.计算直属用户的个数
      allCount += this.countDirectUserNum(perDep, false);
      //2.计算子部门的个数
      for (let j = 0; j < perDep["children"].length; j++) {
        var chilCount = this.countAllUserNum4perDep(perDep["children"][j]);
        perDep["children"][j]["userCheckCount"] = 0; //初始化
        perDep["children"][j]["userAllCount"] = chilCount;
        if (chilCount == 0) perDep["children"][j]["check"] = true;
        else perDep["children"][j]["check"] = false; //其他设为false
        allCount += chilCount;
      }
      perDep["userAllCount"] = allCount; //初始化
      if (allCount == 0) perDep["check"] = true;
      else perDep["check"] = false; //其他设为false
      return allCount;
    },

    //需要找到从父级过来的用户把其设为check状态，
    setUserFromParent() {
      if (this.userFromParent != "") {
        var userArr = this.userFromParent.split(",");
        for (let q = 0; q < this.departmentList.length; q++) {
          this.setUserForCheck(this.departmentList[q], userArr);
          this.countCheckUserNum4perDep(this.departmentList[q]);
          if (userArr == null || userArr.length < 1) break;
        }
      }
    },

    //设置一个部门下特定用户的选中状态，用于增加与会人员和主持人时设置从父级页面带过来的值
    setUserForCheck(perDep, userArr) {
      if (userArr == null || userArr.length < 1) return;
      //获取自己的直接用户
      var usersMap = perDep["userDirectList"];
      for (var key in usersMap) {
        var usersList = usersMap[key];
        for (let i = 0; i < usersList.length; i++) {
          var userIndex = userArr.indexOf(usersList[i].useruuid);
          if (userIndex > -1) {
            //找到这个用户

            usersList[i]["check"] = true;
            //删除这个用户
            userArr.splice(userIndex, 1);
          }
        }
      }
      //获取部门的子部门
      var childrenDeps = perDep["children"];
      for (let j = 0; j < childrenDeps.length; j++) {
        this.setUserForCheck(childrenDeps[j], userArr);
      }
    },

    //设置当前部门的已选人数和这个部门的状态
    setDepartmentCheckStatus() {
      var deparmentWait2Set = [];
      if (this.myMode == "normal") {
        if (this.first) {
          deparmentWait2Set = this.currentDepartmentList;
        } else {
          deparmentWait2Set = this.currentDepartmentList["children"];
        }
      } else if (this.myMode == "search") {
        //4.判断这个部门的已选人数
        if (this.firstSearch) {
          deparmentWait2Set = this.currentDepartmentListSearch;
        } else {
          deparmentWait2Set = this.currentDepartmentListSearch["children"];
        }
      }
      for (let i = 0; i < deparmentWait2Set.length; i++) {
        this.countCheckUserNum4perDep(deparmentWait2Set[i]);
        if (
          deparmentWait2Set[i]["userAllCount"] ==
          deparmentWait2Set[i]["userCheckCount"]
        ) {
          deparmentWait2Set[i].check = true;
        } else {
          deparmentWait2Set[i].check = false;
        }
      }
    },

    //当对部门或者人员取消选择时
    setNoCheck() {
      if (this.myMode == "normal") {
        this.checkAll = false;
        if (!this.first) {
          //不是首页的话
          this.currentDepartmentList["check"] = false;
        }
      } else if (this.myMode == "search") {
        this.checkAllSearch = false;
        if (!this.firstSearch) {
          //不是首页的话
          this.currentDepartmentListSearch["check"] = false;
        }
      }
    },

    //ysy遍历部门设置check的值
    setCheckForDepartment(perDepartment, ifCheck) {
      //1.只把自己的check值设置一下 =>不行，要把其所有的父路径都设为ifCheck
      perDepartment.check = ifCheck;
      //2.要设置自己的用户的
      var usersMap = perDepartment["userDirectList"];
      for (var key in usersMap) {
        var usersList = usersMap[key];
        for (let i = 0; i < usersList.length; i++) {
          usersList[i].check = ifCheck;
        }
      }
      //3.要循环children的
      for (let i = 0; i < perDepartment["children"].length; i++) {
        this.setCheckForDepartment(perDepartment["children"][i], ifCheck); //循环
      }
    },

    //ysy 每次change选择，或者向上或者向下来到页面，都要重新判断一下√
    ifAllCheck() {
      var departmentWait2Check = [];
      var usersMapWait2Check = [];
      if (this.myMode == "normal") {
        if (this.first) {
          //首页
          departmentWait2Check = this.currentDepartmentList;
        } else {
          departmentWait2Check = this.currentDepartmentList["children"];
          usersMapWait2Check = this.currentDepartmentList["userDirectList"];
        }
      } else if (this.myMode == "search") {
        if (this.firstSearch) {
          //首页
          departmentWait2Check = this.currentDepartmentListSearch;
        } else {
          departmentWait2Check = this.currentDepartmentListSearch["children"];
          usersMapWait2Check = this.currentDepartmentListSearch[
            "userDirectList"
          ];
        }
      }
      //对部门判断
      for (let i = 0; i < departmentWait2Check.length; i++) {
        if (departmentWait2Check[i]["check"] == false) {
          //有一个false就返回false
          if (this.myMode == "normal") this.checkAll = false;
          else this.checkAllSearch = false;
          return;
        }
      }
      //如果不是首页需要对用户进行判断
      if (
        (this.myMode == "normal" && !this.first) ||
        (this.myMode == "search" && !this.firstSearch)
      ) {
        for (let key in usersMapWait2Check) {
          var usersList = usersMapWait2Check[key];
          for (let i = 0; i < usersList.length; i++) {
            if (usersList[i]["check"] == false) {
              if (this.myMode == "normal") this.checkAll = false;
              else this.checkAllSearch = false;
              return;
            }
          }
        }
      }
      //说明这个部门下的数据全被选中了
      if (this.myMode == "normal") this.checkAll = true;
      else this.checkAllSearch = true;
    },

    //获取选中的用户的个数
    countCheckUserNum4perDep(perDep) {
      var checkCount = 0;
      //1.计算直属用户的个数 被选中的
      checkCount += this.countDirectUserNum(perDep, true);
      //2.计算子部门的个数
      for (let j = 0; j < perDep["children"].length; j++) {
        var chilCount = this.countCheckUserNum4perDep(perDep["children"][j]);
        perDep["children"][j]["userCheckCount"] = chilCount;
        checkCount += chilCount;
      }
      perDep["userCheckCount"] = checkCount;
      return checkCount;
    },

    //获取直接用户个数[选中的还是所有的]
    countDirectUserNum(perDep, ifCheck) {
      //通过ifCheck判断是计算全部的人，还是选中的人
      var directCount = 0;
      var usersMap = perDep["userDirectList"];
      if (
        usersMap == null ||
        usersMap == "undefined" ||
        Object.keys(usersMap).length < 1
      )
        return directCount;
      for (var key in usersMap) {
        var usersList = usersMap[key];
        if (ifCheck) {
          //要获取选中的人的个数
          for (let i = 0; i < usersList.length; i++) {
            if (usersList[i]["check"] == true) {
              //如果这个用户被选中就加入
              directCount += 1;
            }
          }
        } else {
          //在初始化数据的时候，ifCheck=false;将用户设置为未选中
          directCount += usersList.length;
          for (let i = 0; i < usersList.length; i++) {
            usersList[i]["check"] = false;
          }
        }
      }
      return directCount;
    },

    //搜索符合搜索条件的部门
    searchDepartment(perDep, searchVal) {
      var departmentTemp = [];

      if (perDep["title"].toLowerCase().indexOf(searchVal.toLowerCase()) != -1) {
        //这个部门的名字符合搜索就加入

        departmentTemp.push(perDep);
      }

      for (let j = 0; j < perDep["children"].length; j++) {
        var sub = this.searchDepartment(perDep["children"][j], searchVal);

        departmentTemp.push(...sub);
      }
      return departmentTemp;
    },

    //搜索符合条件的人员
    searchUsers(perDep, searchVal) {
      var usersTemp = [];
      //直接的用户
      var usersMap = perDep["userDirectList"];
      for (var key in usersMap) {
        var usersList = usersMap[key];
        for (let i = 0; i < usersList.length; i++) {
          if (
            usersList[i]["name"]
              .toLowerCase()
              .indexOf(searchVal.toLowerCase()) != -1 ||
            usersList[i]["mobile"].indexOf(searchVal) != -1
          ) {
            //如果这个用户被选中就加入
            let key =
              usersList[i]["py"] == null || usersList[i]["py"].trim() == ""
                ? "#"
                : usersList[i]["py"];
            usersList[i]["py"] = key;
            usersTemp.push(usersList[i]);
          }
        }
      }
      //获取部门的子部门下的用户
      for (let i = 0; i < perDep["children"].length; i++) {
        var childUsers = this.searchUsers(perDep["children"][i], searchVal);
        usersTemp.push(...childUsers);
      }
      return usersTemp;
    },

    covertUserList2Map(usersList) {
      var usersMap = {};
      for (let i = 0; i < usersList.length; i++) {
        let key =
          usersList[i]["py"] == null || usersList[i]["py"].trim() == ""
            ? "#"
            : usersList[i]["py"];

        if (usersMap.hasOwnProperty(key)) {
          usersMap[key].push(usersList[i]);
        } else {
          let userArr = [];
          userArr.push(usersList[i]);
          usersMap[key] = userArr;
        }
      }

      //还要对key排序，还没弄
      return usersMap;
    },

    //搜索时重新初始化搜索有关的字段
    initSearch() {
      this.firstSearch = false; //首页通讯录和其他页通讯录加载不同
      this.departmentStackSearch = []; //根据操作入栈和出栈数据
      this.departmentNaviSearch = []; //头部导航，要pop数据
      this.currentDepartmentListSearch = []; //用户当前所在的部门数据
      this.checkAllSearch = false; //全选的标记
    },
    //在建会时增加人员的
    addPeopleInCreate() {
      if (this.addUserType == "cfparty") {
        this.$store.commit("setmeetingcfparty", this.allUseruuids.join(","));
        this.$store.commit("setmeetingcfpartyname", this.allUserName.join(","));
      } else if (this.addUserType == "cfhost") {
        this.$store.commit("setmeetingcfhost", this.allUseruuids.join(","));
        this.$store.commit("setmeetingcfhostname", this.allUserName.join(","));
      }
      // this.$router.push("/attendmeeting");
      this.$router.go(-1);
    },
    //会控里增加人员的时候
    addPeopleInConf() {
      if (this.allUseruuids.length == 0) {
        this.$toast(this.$t('m.PlsSelectPerson'));
        return;
      }
      this.$http
        .post(addusr, {
          userId: window.sessionStorage.getItem("UUID"),
          cfIdInWeMeet: window.sessionStorage.getItem("cfIdInWeMeet"),
          addUserId: this.allUseruuids.join(",")
        })
        .then(
          res => {
            if (res.data.status == 2000) {
              this.$toast(this.$t('m.PersonAddOK'));
            } else {
              this.$toast(this.$t('m.PersonAddFail'));
            }
            this.$router.push({
              path: "/meetingact",
              query: {
                cf_id: this.$route.query.cf_id,
                mcuId: this.$route.query.mcuId
              }
            });
          },
          err => {
            this.$toast(this.$t('m.PersonAddFail'));
          }
        );
    }
  },

  computed: {
    choice() {
      return " ";
    }
  },
  watch: {
    checkAllGroup(val, oldVal) {
      console.log("checkAllGroup" + val);
    }
  }
};
</script>
<style scoped>
/* #search {
  background-color: #d8d8d8;
  margin-top: 0.2rem;
  padding-left: 0.2rem;
  border: 0px solid rgb(180, 180, 180);
  border-radius: 4px;
  width: 80%;
  height: 0.3rem;
  font-size: 13px;
  text-align: left;
} */

.peoplechoice {
  width: 100%;
}
/* .nav_a {
  text-decoration: underline;
} */
.serch {
  height: 0.52rem;
  line-height: 0.52rem;
  padding: 0 0.15rem;
  font-size: 0.08rem;
  width: 100%;
  position: fixed;
  top: 0.44rem;
  left: 0;
  background-color: #fff;
  z-index: 100;
}

.choice {
  padding: 0.15rem 0.45rem 0.05rem 0.15rem;
  line-height: 0.3rem;
  padding-top: 0.5rem;
}

.serchbox {
  width: 1.9rem;
  height: 0.32rem;
  line-height: 0.32rem;
  display: inline-block;
  border-radius: 5px;
  border: 1px solid #fff;
  /* float: left; */
  margin-right: 0.1rem;
  box-sizing: border-box;
  padding: 0 0.1rem;
}

.searchinput {
  width: 1.2rem;
  height: 0.32rem;
  border: none;
  background-color: transparent;
  outline: none;
  line-height: 0.32rem;
}

i {
  font-size: 0.2rem;
}

.title {
  padding: 0 0.15rem;
  height: 0.28rem;
  background-color: #e8e8e8;
  line-height: 0.28rem;
  font-size: 0.16rem;
  font-weight: bold;
}

.contentitem {
  height: 0.41rem;
  font-size: 0.16rem;
  line-height: 0.41rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.main {
  padding: 0 0 0.5rem;
}

.content {
  padding: 0rem 0.15rem;
  line-height: 0.2rem;
}

.bottom {
  width: 20%;
  height: 0.36rem;
  line-height: 0.36rem;
  color: #fff;
  font-size: 0.18rem;
  text-align: center;
  /* position: fixed; */
  /*bottom: 0px;*/
  /*left: 0px;*/
  /* top: 106px; */
  /* left: 79%; */
}

.bottoma {
  width: 10%;
  height: 0.17rem;
  line-height: 0.2rem;
  color: #fff;
  font-size: 0.1rem;
  text-align: center;
  border-radius: 8px;
  /* position: fixed; */
  margin-top: -0.17rem;
  margin-left: 3.2rem;
  display: block;
  line-height: 150%;
  /*bottom: 0px;*/
  /*left: 0px;*/
  /* top: 106px; */
  /* left: 79%; */
}

.tab-tilte {
  position: absolute;
  top: 108px;
  right: 0px;
  width: 10%;
  background-color: #fff;
  padding: 0;
  height: 75vh;
  overflow-y: scroll;
  float: right;
}

/* .right span {
  padding: 10px;
  color: #32af66;
  width: 100%;
  line-height: 0.2rem;
  display: inline-block;
  text-align: center;
}

.right .active {
  background-color: #32af66;
  color: #fff;
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  line-height: 20px;
} */

.headerpicwarp {
  display: inline-block;
  width: 0.35rem;
  height: 0.41rem;
  line-height: 0.41rem;
  text-align: center;
  float: left;
}

.headerpic {
  width: 0.35rem;
  height: 0.35rem;
  vertical-align: middle;
  float: left;
}

.pop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}

.templatepop {
  width: 3rem;
  height: 3.6rem;
  background-color: #fff;
  border-radius: 5px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -1.8rem;
  margin-left: -1.5rem;
  box-sizing: border-box;
  padding: 0.4rem 0;
  font-size: 0.15rem;
}

.popclosex {
  position: absolute;
  top: 0.1rem;
  right: 0.1rem;
}

/*************************/
.leftspan {
  display: inline-block;
  width: 0.5rem;
  text-align: center;
  margin-left: 0.2rem;
}
.allList {
  margin-top: 0.5rem;
  background-color: #d8d8d8;
  padding: 0.08rem 0.2rem;
}

.departmentList {
  width: 93%;
  /* padding: 0rem 0.2rem; */
  padding-left: 0.1rem;
}
.listName {
  padding: 0.15rem 0.15rem;
  border-bottom: 1px solid #f5f5f5;
}
.rightImg {
  text-align: right;
  display: inline-block;
  float: right;
  width: 50px;
  height: 30px;
  margin-top: -0.15rem;
}
.rightImg img {
  height: 0.13rem;
  line-height: 0.13rem;
}
.listBar {
  /* margin: 0.1rem 0; */
  margin: 0.63rem 0 0.1rem 0;
  padding-left: 0.1rem;
  /* background-color: #D8D8D8; */
  /* padding: 0.08rem 0.2rem; */
}
.demo-breadcrumb-separator {
  color: #ff5500;
  padding: 0 5px;
}
.department {
  font-size: 0.14rem !important;
}
.userInfo {
  width: 100%;
  height: 0.41rem;
  font-size: 0.14rem;
  line-height: 0.41rem;
  margin: 0.05rem 0;
}
.userInfo .username {
  width: 35%;
  display: inline-flex;
  margin-left: 0.1rem;
}
.userInfo .username span {
  width: 115px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.userInfo .userphone {
  width: 35%;
  display: inline-flex;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 0.1rem;
}
.allUser_wrap {
  width: 100%;
  margin-bottom: 0.6rem;
}
.allUser {
  /* float: left; */
  width: 97%;
}
.iossearch {
  position: absolute;
  margin-top: 0.26rem;
}

.top_Bar {
  width: 100%;
  position: fixed;
  top: 0.44rem;
  left: 0;
  border-bottom: 1px solid #f2f1f1;
  display: flex;
  justify-content: space-between;
  padding: 5px 15px;
  line-height: 32px;
  background-color: #fff;
  z-index: 10;
}
.top_Bar_wechat {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  border-bottom: 1px solid #ddd;
  display: flex;
  justify-content: space-between;
  padding: 10px 15px;
  line-height: 32px;
  background-color: #fff;
  z-index: 10;
}
.top_Barlanse {
  width: 100%;
  position: fixed;
  top: 0.22rem;
  left: 0;
  border-bottom: 1px solid #ddd;
  display: flex;
  justify-content: space-between;
  padding: 10px 15px;
  line-height: 32px;
  background-color: #fff;
  z-index: 10;
}
.bottomButtons {
  width: 100%;
  /* display: flex; */
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9999;
}
.bottomButtons > div {
  width: 100%;
  height: 0.49rem;
  line-height: 0.49rem;
  color: #fff;
  font-size: 0.18rem;
  text-align: center;
  border: 1px solid #f3f3f3;
}
.confirm {
  width: 100%;
  /* display: flex; */
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9999;
}
.confirm > div {
  width: 100%;
  height: 0.25rem;
  line-height: 0.25rem;
  color: #fff;
  font-size: 0.12rem;
  text-align: center;
  border: 1px solid #f3f3f3;
}
</style>




// WEBPACK FOOTER //
// src/components/content/userlist.vue